import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { prepareWalletSiws, walletSiws } from "@bkry/bowline-redux/wallets";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";

const SignInWithSolanaButton = (props, context) => {
  const { className, label, color, size, block, outline, onSuccess } = props;
  const { connection } = useConnection();
  const { publicKey, sendTransaction } = useWallet();
  const dispatch = useDispatch();

  const handleClick = async () => {
    if (!connection || !publicKey || !sendTransaction) {
      console.error("Wallet not connected or connection unavailable");
      return;
    }
    const networkToChainId = {
      solana: 1000000001,
      solana_devnet: 1000000002,
    };
    const chainName = connection.rpcEndpoint.includes("devnet")
      ? "solana_devnet"
      : "solana";
    const chainId = networkToChainId[chainName];
    const accountInfo = await connection.getAccountInfo(publicKey);

    console.log("Account Info:", accountInfo);
    const account = publicKey.toString();

    console.log("Account:", account);

    dispatch(
      prepareWalletSiws({
        account,
        chainId,
        callbackSuccess: ({ nonce, nonceIssuedAt, chainId, provider }) => {
          dispatch(
            walletSiws({
              account,
              nonce,
              nonceIssuedAt,
              provider,
              chainId,
              callbackSuccess: () => {
                onSuccess ? onSuccess() : null;
              },
            })
          );
        },
      })
    );
  };

  return (
    <Button
      onClick={handleClick}
      className={className}
      color={color}
      size={size}
      block={block}
      outline={outline}
    >
      {label ? label : context.t("Sign in with Solana")}
    </Button>
  );
};

/**  define proptype for the 'translation' function  */
SignInWithSolanaButton.contextTypes = {
  t: PropTypes.func,
};

SignInWithSolanaButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  block: PropTypes.bool,
  outline: PropTypes.bool,
  onSuccess: PropTypes.func,
};

SignInWithSolanaButton.defaultProps = {
  color: "secondary",
  size: "md",
  block: false,
  outline: false,
};

export default SignInWithSolanaButton;
